import { render, staticRenderFns } from "./TaggingModeratorComponent.vue?vue&type=template&id=af3b0eee&"
import script from "./TaggingModeratorComponent.vue?vue&type=script&lang=js&"
export * from "./TaggingModeratorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports